import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TTableV2, TTheme, TThemeStyles } from './models';

export const TableV2: FC<TTableV2> = ({ children, styles, theme = 'white' }) => {
    return (
        <table className={cn(styles.table, styles[`${theme}Theme` as TThemeStyles[TTheme]])}>
            {children}
        </table>
    );
};
